const SecondElement = function(value, elementPosition, secondPosition) {
  this.value = value;
  this.elementPosition = elementPosition;
  this.secondPosition = secondPosition;
}

export default SecondElement
